const getFeaturedItemImage = () => {
  const featuredItems = document.querySelectorAll(".featured-items");

  if (featuredItems.length > 0) {
    featuredItems.forEach((block) => {
      const featured_item_group = block.querySelectorAll(".featured-item");

      if (featured_item_group.length > 0) {
        featured_item_group.forEach((item) => {
          const type = item.dataset.type;
          const id = item.dataset.id;

          const getFloatingImage = async () => {
            try {
              const res = await fetch("/pages/products_json");
              if (res.ok) {
                const data = await res.json();

                const product = data.find(
                  (product) => product.product_id === id
                );

                if (product.floating_image) {
                  item.querySelector(".featured-item__image").src =
                    product.floating_image;
                }
              } else {
                console.error(`There was an error: ${res}`);
              }
            } catch (error) {
              console.error(`There was an error: ${error}`);
            }
          };

          if (type === "product") {
            getFloatingImage();
          }
        });
      }
    });
  }
};

export default getFeaturedItemImage;
